import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCaretUp = () => {
  return (
    <g>
      <path d="M13.254 12a.695.695 0 0 0 .526-.26c.267-.316.29-.81.073-1.158l-.073-.1L8.53 4.26l-.084-.086a.66.66 0 0 0-.901.007l-.076.08-5.248 6.217-.073.1a1.024 1.024 0 0 0 0 1.058l.073.1.084.085c.132.117.29.175.446.175V12h10.504z" />
    </g>
  );
};

export default withIcon(IconCaretUp);
